import { PescadorService } from './../../services/solicitante/pescador.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { Component, Inject, OnInit } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { SolicitanteService } from 'src/app/services/solicitante/solicitante.service';
import { Pescador } from './../../models/pescador';
import { forkJoin, pipe } from 'rxjs';
import { Router } from '@angular/router';
import { async } from '@angular/core/testing';
import { formatDate } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
  selector: 'app-recibopublico',
  templateUrl: './recibopublico.component.html',
  styleUrls: ['./recibopublico.component.css']
})
export class RecibopublicoComponent implements OnInit {
  format = 'dd/MMM/yyyy';
  fechaActual: string;
  empresa: string;
  email: string;
  direccion: string;
  ciudad: string;
  estado: string;
  pipe: Date;
  totalsumatoriatabla: number;
  identificadousuario: string;
  listapescador: Pescador[];

  numerorecibo: string;
  numerotocket: string;
  total: number;
  descripcion = 'Permmisos de Dia';
  Tottalpagar: string;

  concepto: string;
  costoindividual: string ;
cantidad: string;
sumatoriatotal: number;

  pagina: string;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private solicitanteService: SolicitanteService,
    private usuarioService: UsuarioService,
    private pescadorService: PescadorService,
    private router: Router,
    public dialogRef: MatDialogRef<RecibopublicoComponent>
  ) { }

  ngOnInit() {
    this.empresa = '';
    this.email = '';
    this.fechaActual = '';

    this.listapescador = this.data.listadospescadores;
    this.sumatoriatotal = this.data.totalsumatoria;
    console.log ('listdso transferidos', this.listapescador);

      this.identificadousuario = localStorage.getItem('idsolicitante');











      }


      async crearReporte() {

        const doc = new jsPDF('p','mm','letter');

        const img = new Image();
        img.src = '../../../assets/logosmx.png';




        doc.setLineWidth(3);
        // doc.setDrawColor(255, 0, 0);



        doc.setFillColor(0, 131, 185);
        doc.roundedRect(0, 0, 55, 280, 0, 0, 'F');
       // doc.roundedRect(110, valortop, 90, 41, 5, 5, 'F');

        const valortopinicial = 10;
        let valortop = valortopinicial ; // canbiabdo este numero se mueve todo hacia abajo

        // logo sportfishing
        doc.addImage(img, 'png', 3, valortop, 50, 44);



        valortop = valortop + 60 ;  // cambiando este numero baja todo le texto bara abajo
        doc.setFontSize(15);
        doc.setFontType('bold');
        doc.text(8, valortop, 'SportfishingMX' );

        valortop = valortop + 4 ;  // cambiando este numero baja todo le texto bara abajo
        doc.setFontSize(8);
        doc.setFontType('normal');
        doc.text(13, valortop, 'www.sportfishingmx.com' );

        valortop = valortop + 5 ;  // cambiando este numero baja todo le texto bara abajo
        doc.setFontSize(8);
        doc.setFontType('normal');
        doc.text(13, valortop, 'info@sportfishingmx.com' );


        valortop = valortop + 10 ;
        doc.setFontSize(10);
        doc.setFontType('normal');
        doc.text(4, valortop, '511 E. San Ysidro Blvd. # 7129' );


        valortop = valortop + 4 ;
        doc.setFontSize(8);
        doc.text(13, valortop, 'San Ysidro, CA 92173' );

        valortop = valortop + 10 ;
        doc.setFontSize(10);
        doc.text(10, valortop, 'Apartado Postal #24' );

        valortop = valortop + 4 ;
        doc.setFontSize(8);
        doc.text(15, valortop, 'Rosarito B.C. 22710' );

        console.log ('**************************');


        valortop = valortopinicial ;


        valortop = valortop + 20 ;
        doc.setFontType('bold');
        doc.setFontSize(35);
        doc.text(115, valortop, 'RECEIPT' );


        valortop = valortop + 8 ;  // cambiando este numero baja todo le texto bara abajo
        doc.setFontSize(9);
        doc.setFontType('normal');
        doc.text(115, valortop, 'Confirmation Number' );

        valortop = valortop + 5 ; // cambinaod este numero es le espacio entre renglones
        doc.setFontSize(13);
        doc.text(115, valortop, this.numerotocket);

        valortop = valortop + 5 ;
        doc.setFontSize(9);
        doc.setFontType('normal');
        doc.text(115, valortop, 'Receipt Number' );

        valortop = valortop + 5 ;
        doc.setFontSize(13);
        doc.text(115, valortop, this.numerorecibo);

        valortop = valortop + 5 ;
        const locale = 'en-US';
        const formattedDate = formatDate(this.fechaActual, this.format, locale);
        doc.setFontSize(9);
        doc.setFontType('normal');
        doc.text(115, valortop, 'Date' );

        valortop = valortop + 5 ;
        doc.setFontSize(13);
        doc.text(115, valortop, formattedDate);




        valortop = valortop + 10 ;
        const espacios = 7;







        const margen = 75;
        doc.setFontSize(12);
        doc.setFontType('bold');
        doc.text(margen, valortop, 'SOLD TO: ');
        doc.setFontSize(11);
        valortop += 10;
        doc.text(margen, valortop, this.empresa);
        doc.setFontType('normal');
        valortop += 5;
        doc.text(margen, valortop,  this.email);
        valortop += 5;


        const posiciontopdetalles = valortop + 30 ;
        valortop = posiciontopdetalles;





      //  doc.autoTable({ html: '#basic-table' })
       // valortop = posiciontopdetalles;





       var options = {

        startY: doc.autoTableEndPosY() + 20
      };




        // await doc.autoTable({ html: '#basic-table',options })

        const res = doc.autoTableHtmlToJson(document.getElementById('basic-table'));
        doc.autoTable(res.columns, res.data, {margin: {top: valortop, left: 60},
          tableWidth: 'auto',
          styles: {fontSize: 12, overflow: 'linebreak'},
          columnStyles: {
            0: {columnWidth: "50"},
            1: {columnWidth: "10",halign: 'center'},
            2:{columnWidth:"10",halign: 'center'},
            3: {columnWidth: "10",halign: 'center'},
          }
           }),

           doc.setFontSize(18);
           doc.setFontType('bold');
           doc.text(margen + 40 , valortop + 42, 'Balance Paid (USD) $' + this.sumatoriatotal);





        await doc.save(  'aaa.pdf');
























    }







        localizaTicket() {


          console.log ('el id encontrado es ' + this.identificadousuario);

        this.solicitanteService.buscarReciboSolicitantepublico( this.identificadousuario )
        .subscribe ( resp => {





           this.fechaActual = resp.solicitante.creado;
           this.numerorecibo = resp.solicitante.numeroperacion;


           this.concepto = resp.pescadores.tipolicencia;
           this.numerotocket = resp.solicitante.numeroconfirmacion;
           this.empresa = resp.solicitante.nombre;
           this.email = resp.solicitante.email;


           const vtotalpagar: string = resp.pescadores.costolicencia;
           this.Tottalpagar = (Number(vtotalpagar).toFixed(2)).toString();




           this.crearReporte();

          this.cerrarventana();

        });






      }





      localizaTicketprecompra() {

        console.log ('el id encontrado es ' + this.identificadousuario);

        this.solicitanteService.buscarReciboSolicitante( this.identificadousuario )
        .subscribe ( resp => {
           console.log ( 'este es la respuesta', resp);

           this.fechaActual = resp.precompra.fecha;
           this.numerorecibo = resp.movimiento[0].numeroperacion;
           this.concepto = resp.movimiento[0].concepto;
           this.numerotocket = resp.precompra.refenciapaypal;
           this.empresa = resp.precompra.idempresa.nombreEmpresa;
           this.email = resp.precompra.idempresa.email;
           this.direccion = resp.precompra.idempresa.direccion;
           this.ciudad = resp.precompra.idempresa.ciudad;
           this.estado = resp.precompra.idempresa.estado;

           const vcantidad: string = resp.precompra.clicencia;
           this.cantidad = vcantidad.toString();
           const vtotalpagar: string = resp.precompra.totalpagado;
           this.Tottalpagar = (Number(vtotalpagar).toFixed(2)).toString();

           this.costoindividual = (Number(vtotalpagar) / Number (vcantidad)).toString();

           this.crearReporte();

           this.cerrarventana();

        });



       }












      delay(ms: number) {
        return new Promise( resolve => setTimeout(resolve, ms) );
    }



    cerrarventana() {
      this.dialogRef.close();
    }





    }
